import { Column, ColumnConfig, IColumn } from "../base-column/column.model";
import { ColumnTypeEnum } from "../base-column/column-type-enum";
import { CustomSwitchFunction } from "../common-models/custom-enum.model";
import { SeverityEnum } from "./severity-enum";
import { initFromConfig, initFromProps } from "../common-models/init-functions";


export class LabelColumn<T> extends Column<T> implements IColumn<T>{

  Cases: { [key: symbol]: () => T } = {};

  constructor(config: ColumnConfig<T>);
  constructor(
    name?: string,
    propertyName?: string,
    cases?: { [key: symbol]: () => T },
    tooltip?: string | ((item?: any) => string),
    action?: (item?: T, event? : any) => any
  );
  constructor(
    configOrName?: ColumnConfig<T> | string,
    propertyName?: string,
    cases?: { [key: symbol]: () => T },
    tooltip?: string | ((item?: any) => string),
    action?: (item?: T, event? : any) => any,
  ) {
    super();
    if (typeof configOrName === 'object') {
      const config = configOrName as ColumnConfig<T>;
      initFromConfig(this, config);
    } else {
      initFromProps(this, configOrName, propertyName, undefined, tooltip, action, cases);
    }
  }

  GetAction(row: T, event? : any) {
    if (this.Action) {
      return this.Action(row, event);
    } else {
      throw new Error('Action is not defined in label column.');
    }
  }

  GetTooltip(): string | ((item?: any) => string) {
    return this.Tooltip ?? null;
  }

  GetSort(): boolean {
    return false;
  }
  GetPropertyName(): string{
    return this.PropertyName ?? null;
  }
  GetName(): string {
    return this.Name ?? '';
  }
  //Θα επιστρέφει το αντίστοιχο entry από το Enum για DateColumn
  GetColumnType(): string {
    return ColumnTypeEnum.LabelColumn;
  }

  //Θα πρέπει να επιστρέφει το value που θα εμφανιστεί στο grid βασισμένο στο Propertyname μετά από τους μετασχηματισμούς.
  //Για την υποστήριξη των nested object θα πρέπει να υπάρχει split και recursive αναζήτηση των properties.
  GetValue(): string | ((item?: any) => string){
    return this.Action ?? '';
  }

  GetSeverity(obj?: T): SeverityEnum {
    const status = obj != undefined ? obj : '';
    return CustomSwitchFunction<SeverityEnum>(status, this.Cases);
  }
}
